import React from "react";
import type { MobileTimelineRow } from "../../mobileConsultantAgendaModel";
import MobileScheduleItem from "./MobileScheduleItem";
import type { ScheduleVisitOutcome } from "../../../../services/scheduleVisitOutcome";

type MobileScheduleListProps = {
  heading: string;
  rows: MobileTimelineRow[];
  visitsCount: number;
  freeSlotsCount: number;
  onPressVisit: (coord: string, scheduleId?: number) => void;
  onPressFreeSlot: (coord: string) => void;
  /** Unlock a blocked slot; omitted when the viewer cannot change this agenda. */
  onUnlockSlot?: (coord: string) => void;
  onMarkOutcome: (
    row: MobileTimelineRow,
    outcome: ScheduleVisitOutcome,
    scheduleIds?: number[]
  ) => Promise<void>;
};

const MobileScheduleList: React.FC<MobileScheduleListProps> = ({
  heading,
  rows,
  visitsCount,
  freeSlotsCount,
  onPressVisit,
  onPressFreeSlot,
  onUnlockSlot,
  onMarkOutcome,
}) => (
  <section>
    <div className="mb-3 flex items-baseline justify-between gap-2 px-0.5">
      <h2 className="text-lg font-semibold leading-tight text-[#2D3748]">
        {heading}
      </h2>
      <p className="text-sm text-[#718096]">
        <span className="font-semibold text-[#2D3748]">{visitsCount}</span> visitas ·{" "}
        <span className="font-semibold text-[#2D3748]">{freeSlotsCount}</span> livres
      </p>
    </div>
    <ul className="list-none space-y-3 p-0">
      {rows.map((row) => (
        <MobileScheduleItem
          key={row.coord}
          row={row}
          onPressVisit={onPressVisit}
          onPressFreeSlot={onPressFreeSlot}
          onUnlockSlot={onUnlockSlot}
          onMarkOutcome={onMarkOutcome}
        />
      ))}
    </ul>
  </section>
);

export default MobileScheduleList;
